import { Textarea } from "../../primitive/textarea";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface FormTextareaProps extends Omit<
  React.ComponentProps<typeof Textarea>,
  "value" | "onChange" | "name"
> {
  showErrorMessage?: boolean;
}

function FormTextarea({
  showErrorMessage = true,
  ...textareaProps
}: FormTextareaProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <Textarea
        id={field.name}
        name={field.name}
        value={field.state.value ?? ""}
        onChange={(event) => field.handleChange(event.target.value)}
        {...textareaProps}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormTextarea };
